<template>
  <div
    ref="scheduleContainer"
    class="courseCalendar-container"
  >
    <!-- <el-table :data="tableData" border class="courseCalendar-container" :show-header="false" :row-class-name="tableRowClassName">
        <el-table-column :key="key" v-for="{key, value} in headerList" :prop="'col'+ key" :label="value">
        </el-table-column>
    </el-table> -->
    <table class="">
      <tr :style="{height:headerRowHeight +'px'}">
        <th
          :key="item.key"
          :width="getTableColumnWidth(index)"
          v-for="(item, index) in headerList"
          :class="{'calendar-disabled-cell':!!item.disabled}"
        >{{item.value}}</th>
      </tr>
      <tr
        :style="{height:rowHeight+'px'}"
        :key="indexRow"
        v-for="(row, indexRow) in tableData"
        :class="tableRowClassName(indexRow)"
      >
        <td
          :class="{'calendar-header-column-cell':indexCol == 0, 'calendar-disabled-cell':col.disabled || (indexCol != 0 && col.isUnavailable) || (indexCol == 0 && col.isTimeColUnavailable), 'calendar-pointer': indexRow < tableData.length}"
          :key="indexCol"
          v-for="(col, indexCol) in row"
          @dblclick="onDblClickTd(col)"
          @click="onClickTd(col)"
        >
          <span>{{col.value}}</span>
        </td>
      </tr>
    </table>
    <calendarColorBlock
      @edit="editBlock"
      @editDoubleClick="editBlockDoubleClick"
      :key-value="item.keyValue"
      v-for="item in scheduleData"
      :key="item.key"
      :color="item.color"
      :fontColor="item.fontColor"
      :width="item.width"
      :tooltip-text="item.tooltipText"
      :tooltipTextList="item.tooltipTextList"
      :active="item.active"
      :height="item.height"
      :left="item.left"
      :top="item.top"
      :title="item.title"
      :text="item.text"
      :fontSize="blockFontSize"
      :lineHeight="lineHeight"
    ></calendarColorBlock>
  </div>
</template>

<style lang="scss">
.courseCalendar-container {
  margin: 1px;
  width: 100%;
  height: 100%;
  position: relative;

  table {
    width: 100%;
    border-color: #ced3d9;
    border: 1px solid #ced3d9;
    tr {
      //pointer-events: none;
      th {
        border-color: #ced3d9;
        border: 1px solid #ced3d9;
        color: #222222;
        text-align: center;

        &.calendar-disabled-cell {
          color: #b5b5b5;
        }
      }
      td {
        border-color: #ced3d9;
        border: 1px solid #ced3d9;
        color: #222222;
        text-align: left;
        padding-left: 10px;
        font-size: 12px;
        .cell {
          white-space: nowrap;
        }

        &.calendar-pointer {
          cursor: pointer;
        }

        &.calendar-disabled-cell {
          background-color: #f7f7f7;

          &.calendar-pointer {
            cursor: default;
          }
        }

        &.calendar-header-column-cell {
          border-top: none;
          border-right: none;
          border-bottom: none;
          background-color: transparent;
          position: relative;
          span {
            display: block;
            position: absolute;
            bottom: -8px;
            right: 10px;
          }

          &.calendar-disabled-cell {
            background-color: transparent;
          }
        }
      }

      .calendar-disabled-cell {
        color: #b5b5b5;
        background-color: #f7f7f7;
      }
    }
    .header_row {
      td {
        text-align: center;
        font-weight: bold;
      }
    }
    .color_row {
      td {
        background-color: #e1edf7;

        &.calendar-disabled-cell {
          background-color: #e5e5e5;
        }
      }
    }
  }
}
</style>

<script>
import {
  formatTime,
  formatTimeToInt60,
  formatTimeFromInt60
} from "../config/mUtils";
import calendarColorBlock from "./calendarColorBlock";

export default {
  data() {
    return {
      screenWidth: document.body.clientWidth,
      originalHeaderList: [
        { key: 0, value: "时间", disabled: false },
        { key: 1, value: "周一", disabled: false },
        { key: 2, value: "周二", disabled: false },
        { key: 3, value: "周三", disabled: false },
        { key: 4, value: "周四", disabled: false },
        { key: 5, value: "周五", disabled: false },
        { key: 6, value: "周六", disabled: false },
        { key: 7, value: "周日", disabled: false }
      ],
      localOptions: {},
      headerList: [],
      tableData: [],
      scheduleData: [],
      scheduleSortedData: [],
      colWidth: 100,
      colTotalWidth: 100,
      headerColWidth: 100,
      headerRowHeight: 25,
      rowHeight: 20,
      totalRowCount: 1,
      startHourDefault: 8,
      endHourDefault: 23,
      startMinuteDefault: 0,
      endMinuteDefault: 0,
      blockFontSize: "14px",
      lineHeight: "18px"
    };
  },
  created() {
    this.loadOptions();
  },
  props: {
    options: {
      start: Number,
      end: Number,
      oneDayOnly: Boolean,
      headers: Array,
      fontSize: String,
      hasCustomHeader: Boolean,
      unavailableTime: Object
    },
    selectedDay: Number,
    schedules: Array //结构starttime, endtime, dayofweek, title, text, color
  },
  methods: {
    onClickTd(col) {
      if (col.colIndex >= 0 && !col.disabled && !col.isUnavailable) {
        this.$emit("add", col);
      }
    },
    onDblClickTd(col) {},
    setFontSize() {
      if (!!this.localOptions.fontSize) {
        this.blockFontSize = this.localOptions.fontSize;
        this.lineHeight = this.localOptions.fontSize;
      }
    },
    getTableColumnWidth(index) {
      if (index == 0) {
        return this.headerColWidth;
      } else {
        if (this.localOptions.oneDayOnly) {
          return this.colTotalWidth;
        } else {
          return this.colWidth;
        }
      }
    },
    getTableData() {
      let startHourTime = this.startHourDefault;
      let endHourTime = this.endHourDefault;
      let startMinuteTime = this.startMinuteDefault;
      let endMinuteTime = this.endMinuteDefault;

      if (typeof this.localOptions.start != "undefined") {
        let numStart = this.localOptions.start;
        startHourTime = Math.floor(numStart);
        startMinuteTime = (numStart - startHourTime) * 60;
      }
      if (typeof this.localOptions.end != "undefined") {
        let numEnd = this.localOptions.end;
        endHourTime = Math.floor(numEnd);
        endMinuteTime = (numEnd - endHourTime) * 60;
      }

      let tableData = [];

      let startTime = startHourTime + startMinuteTime / 60;
      let endTime = endHourTime + endMinuteTime / 60;
      let count = endTime - startTime;
      if (count < 0) {
        count = 0;
      }

      this.totalRowCount = count * 2 + 2;
      let colCount = this.headerList.length;

      // if (this.localOptions.oneDayOnly) {
      //   colCount = 1;
      // }

      let offset = startMinuteTime > 0 ? 1 : 0;
      for (let i = 0; i < this.totalRowCount; i++) {
        let rowData = [];

        let n = i;
        let hour = startHourTime + Math.floor((n + offset) / 2);
        let mintue = (startMinuteTime + (n % 2) * 30) % 60;
        let hourEnd = hour;
        let minuteEnd = ((n % 2) * 30) % 60;
        if ((n + offset) % 2 == 1) {
          hourEnd = hour + 1;
        }
        let startTimeThisValue = hour * 60 + mintue - 30;
        let endTimeThisValue = hourEnd * 60 + minuteEnd - 30;
        let startTimeThis = formatTimeFromInt60(startTimeThisValue);
        let endTimeThis = formatTimeFromInt60(endTimeThisValue);
        let isUnavailable = false;
        let isTimeColUnavailable = false;
        if (!!this.localOptions && !!this.localOptions.unavailableTime) {
          if (
            this.localOptions.unavailableTime.startTime <= endTimeThisValue &&
            this.localOptions.unavailableTime.endTime >= startTimeThisValue
          ) {
            isUnavailable = true;
          }
          if (
            this.localOptions.unavailableTime.startTime <=
              endTimeThisValue + 30 &&
            this.localOptions.unavailableTime.endTime >= startTimeThisValue + 30
          ) {
            isTimeColUnavailable = true;
          }
        }

        if (i == 0 || i == this.totalRowCount - 1) isUnavailable = true;
        if (i == this.totalRowCount - 2) isTimeColUnavailable = true;

        for (let j = 0; j < colCount; j++) {
          //计算电脑不可用时间段
          let isColUnavailable = false;
          let header = this.headerList[j];
          if (!!header.unavailableTimeItems && header.unavailableTimeItems.length > 0) {
            header.unavailableTimeItems.some(function(item, index) {
              if (startTimeThisValue >= item.startTime && startTimeThisValue < item.endTime) {
                isColUnavailable = true;
                return true;
              }

              return false;
            });
          }

          let colData = {};
          colData.rowIndex = i;
          colData.colIndex = j - 1; //j为0是第一列，时间label列，不进行计数
          colData.startTime = startTimeThis;
          colData.isUnavailable = isUnavailable || isColUnavailable;
          colData.isTimeColUnavailable = isTimeColUnavailable;

          if (j > 0) {
            colData.disabled = !!this.headerList[j].disabled;
            colData.key = this.headerList[j].key;
          }

          if (j == 0 && i != this.totalRowCount - 1) {
            colData.value = formatTimeFromInt60(startTimeThisValue + 30);
            //rowData.push(startTimeThis);
          } else {
            colData.value = "";
            //rowData.push("");
          }

          rowData.push(colData);
        }

        tableData.push(rowData);
      }

      return tableData;
    },
    tableRowClassName(rowIndex) {
      if (rowIndex % 2 == 1) {
        return "color_row";
      }
      return "";
    },
    getColWidth() {
      if (!this.$refs.scheduleContainer.clientWidth) {
        return false;
      }
      this.colTotalWidth =
        this.$refs.scheduleContainer.clientWidth - this.headerColWidth;

      let colCount = this.headerList.length - 1;
      if (this.localOptions.oneDayOnly) {
        colCount = 1;
        if (!!this.scheduleSortedData && this.scheduleSortedData.length > 0) {
          this.colWidth = this.colTotalWidth / this.scheduleSortedData.length;
        } else {
          this.colWidth = this.colTotalWidth;
        }
      } else {
        this.colWidth = this.colTotalWidth / colCount;
      }
      return true;
    },
    sortScheduleList() {
      if (this.schedules.length == 0) {
        this.scheduleSortedData = [];
        return;
      }

      let scheduleSortedList = [];
      for (let i = 0; i < this.schedules.length; i++) {
        this.putElementInList(scheduleSortedList, this.schedules[i], 0);
      }
      this.scheduleSortedData = scheduleSortedList;
    },
    putElementInList(scheduleSortedList, element, index) {
      let startTime = formatTimeToInt60(element.starttime);
      let endTime = formatTimeToInt60(element.endtime, true);
      if (scheduleSortedList.length == index) {
        scheduleSortedList.push([]);
        scheduleSortedList[index].push(element);
        return;
      }
      let list = scheduleSortedList[index];
      let isFind = false;
      list.forEach(item => {
        let startTimeItem = formatTimeToInt60(item.starttime);
        let endTimeItem = formatTimeToInt60(item.endtime, true);
        if (startTimeItem < endTime && endTimeItem > startTime) {
          isFind = true;
          return;
        }
      });
      if (isFind) {
        index++;
        this.putElementInList(scheduleSortedList, element, index);
      } else {
        scheduleSortedList[index].push(element);
      }
    },
    loadScheduleData() {
      if (!!this.schedules) {
        //this.scheduleData = [];
        let list = [];
        
        if (this.localOptions.oneDayOnly) {
          this.sortScheduleList();
          this.getColWidth();
          if (!!this.scheduleSortedData) {
            let index = 1;
            for (let i = 0; i < this.scheduleSortedData.length; i++) {
              let columnData = this.scheduleSortedData[i];
              for (let j = 0; j < columnData.length; j++) {
                let item = columnData[j];
                let itemData = this.getCalendarItem(item, i, index);
                list.push(itemData);
                index++;
              }
            }
          }
        } else {
          let index = 0;
          for (
            let headerIndex = 1;
            headerIndex < this.headerList.length;
            headerIndex++
          ) {
            let header = this.headerList[headerIndex];

            let scheduleDayList = this.schedules.filter(
              m => m.dayofweek == header.key || m.groupKey == header.key
            );
            if (scheduleDayList.length > 0) {
              let scheduleSortedList = [];
              scheduleDayList.forEach(element => {
                this.putElementInList(scheduleSortedList, element, 0);
              });

              let width = this.colWidth / scheduleSortedList.length;
              for (let i = 0; i < scheduleSortedList.length; i++) {
                let columnData = scheduleSortedList[i];
                for (let j = 0; j < columnData.length; j++) {
                  let item = columnData[j];

                  let colIndex = headerIndex - 1;
                  let itemData = this.getCalendarItem(item, colIndex, index);
                  itemData.subColCount = scheduleSortedList.length;
                  if (scheduleSortedList.length > 1) {
                    itemData.subColIndex = i;
                    itemData.width = width;
                    itemData.left = itemData.left + width * i;
                  }
                  list.push(itemData);
                  index++;
                }
              }
            }
          }
        }

        this.scheduleData = list;
        this.resize();
      }
    },
    getCalendarItem(item, colIndex, keyValue) {
      let startRowIndex = this.getTimeRowIndex(item.starttime);
      let endRowIndex = this.getTimeRowIndex(item.endtime);
      let rowCount = endRowIndex - startRowIndex;
      if (rowCount <= 0) {
        rowCount = 1;
      }

      let color = item.color;
      if (!color) {
        color = "#42b983";
      }
      let left = this.headerColWidth + this.colWidth * colIndex;
      if (colIndex > 0) {
        left--;
      }
      if (left < 0) {
        left = 0;
      }
      let top = this.headerRowHeight + this.rowHeight * (startRowIndex + 1);
      let itemData = {
        key: keyValue,
        color: color,
        fontColor: item.fontColor,
        width: this.colWidth,
        height: this.rowHeight * rowCount,
        left: left,
        top: top,
        title: item.title,
        text: item.text,
        tooltipText: item.tooltipText,
        tooltipTextList: item.tooltipTextList,
        keyValue: item.keyValue,
        startRowIndex: startRowIndex,
        endRowIndex: endRowIndex,
        columnIndex: colIndex,
        active: false
      };
      return itemData;
    },
    setBlocksSize(list, columnIndex) {
      if (typeof columnIndex == "undefined") {
        for (let i = 0; i < this.headerList.length; i++) {
          this.setBlocksSize(list, columnIndex);
        }
      } else {
        let someColList = list
          .filter(i => i.columnIndex == columnIndex)
          .sort(function(a, b) {
            return a.startRowIndex - b.startRowIndex;
          });
        if (someColList.length > 1) {
          let startHourTime = this.startHourDefault;
          let endHourTime = this.endHourDefault;

          if (typeof this.localOptions.start != "undefined") {
            startHourTime = this.localOptions.start;
          }
          if (typeof this.localOptions.end != "undefined") {
            endHourTime = this.localOptions.end;
          }

          //计算时间覆盖
          let timeList = [];
          someColList.forEach(element => {
            let startRowIndex = element.startRowIndex;
            let endRowIndex = element.endRowIndex;
            let timeListThis = [];
            for (let i = 0; i < this.totalRowCount - 2; i++) {
              let value = 0;
              if (i >= startRowIndex && i <= endRowIndex) {
                value = 1;
              }
              timeListThis.push(value);
            }
          });
        }
      }
    },
    resize() {
      if (!this.getColWidth()) {
        return;
      }

      let tableCtrl = this.$refs.scheduleContainer.getElementsByTagName(
        "table"
      );
      let startY = 0;
      let startX = 0;
      let rows = [];
      if (tableCtrl && tableCtrl.length > 0) {
        rows = tableCtrl[0].getElementsByTagName("tr");
        if (rows && rows.length > 0) {
          let headerRec = rows[0].getBoundingClientRect();
          //startY = headerRec.y;
          //startX = headerRec.x;

          if (headerRec.top) {
            startY = headerRec.top;
          } else if (headerRec.y) {
            startY = headerRec.y;
          }

          if (headerRec.left) {
            startX = headerRec.left;
          } else if (headerRec.x) {
            startX = headerRec.x;
          }
        }
      }

      this.scheduleData.forEach(element => {
        let left =
          this.headerColWidth + this.colWidth * element.columnIndex - 1;
        if (left < 0) {
          left = 0;
        }

        let top = 0;
        if (
          !!rows &&
          rows.length > 0 &&
          element.startRowIndex + 1 < rows.length &&
          element.endRowIndex + 1 < rows.length
        ) {
          let startRec = rows[
            element.startRowIndex + 1
          ].getBoundingClientRect();
          let yStartRec = 0;
          if (startRec.top) {
            yStartRec = startRec.top;
          } else if (startRec.y) {
            yStartRec = startRec.y;
          }

          top = yStartRec - startY + startRec.height;
          let endRec = rows[element.endRowIndex + 1].getBoundingClientRect();
          let yEndRec = 0;
          if (endRec.top) {
            yEndRec = endRec.top;
          } else if (endRec.y) {
            yEndRec = endRec.y;
          }
          element.height = yEndRec - yStartRec; 
       
        } else {
          top =
            this.headerRowHeight + this.rowHeight * (element.startRowIndex + 1);
        }
        if (element.subColCount > 1) {
          let width = this.colWidth / element.subColCount;
          element.width = width;
          element.left = left + width * element.subColIndex;
        } else {
          element.width = this.colWidth;
          element.left = left;
        }
        element.top = top;
      });
    },
    getTimeRowIndex(time) {
      let startHourTime = this.startHourDefault;
      let endHourTime = this.endHourDefault;

      if (typeof this.localOptions.start != "undefined") {
        startHourTime = this.localOptions.start;
      }
      if (typeof this.localOptions.end != "undefined") {
        endHourTime = this.localOptions.end;
      }
      let strHour = "";
      let strMinue = "";
      time = time.toLowerCase();

      if (time.indexOf(":") > 0) {
        let list = time.split(":");
        if (list.length > 1) {
          strHour = list[0];
          strMinue = list[1];
        }
      } else {
        strHour = time;
      }

      if (time.indexOf("am") > 0) {
        strMinue = strMinue.replace("am", "");
      } else if (time.indexOf("pm") > 0) {
        strMinue = strMinue.replace("pm", "");
      }

      let hour = this.tryParseInt(strHour);
      if (time.indexOf("pm") > 0 && hour < 12) {
        hour += 12;
      }
      if (time == "12:00 am"){
        hour = 24;
      }
   
      let mintue = this.tryParseInt(strMinue);
      let count = hour - startHourTime;
      if (count < 0) {
        return 0;
      }
      let index = count * 2;
      if (mintue > 0) {
        index++;
      }
      return index;
    },
    tryParseInt(str) {
      if (!!str) {
        try {
          return parseInt(str);
        } catch (e) {}
      }
      return 0;
    },
    editBlock(keyValue) {
      this.scheduleData.forEach(element => {
        if (element.keyValue == keyValue) {
          element.active = true;
        } else {
          element.active = false;
        }
      });
      this.$emit("editBlock", keyValue);
    },
    editBlockDoubleClick(keyValue) {
      this.$emit("editDoubleClick", keyValue);
    },
    loadOptions() {
      if (!this.localOptions) {
        this.localOptions = {};
      }
      this.getCustomHeader();
      this.tableData = this.getTableData();
      this.setFontSize();
    },
    getCustomHeader() {
      this.headerList = [];
      if (this.localOptions.hasCustomHeader) {
        if (
          !!this.localOptions.headers &&
          this.localOptions.headers.length > 0
        ) {
          this.localOptions.headers.forEach(element => {
            this.headerList.push(element);
          });
        }

        this.headerList.splice(0, 0, this.originalHeaderList[0]);
      } else {
        if (this.localOptions.oneDayOnly) {
          this.headerList.push(this.originalHeaderList[0]);
          if (
            this.selectedDay > 0 &&
            this.selectedDay < this.originalHeaderList.length
          ) {
            this.headerList.push(this.originalHeaderList[this.selectedDay]);
          }
        } else {
          this.headerList = this.originalHeaderList;
        }
      }
    },
    refresh() {
      this.resize();
    }
  },
  mounted() {
    this.getColWidth();
    this.loadScheduleData();
    const that = this;
    if (window.addEventListener) {
      // most non-IE browsers and IE9
      window.addEventListener(
        "resize",
        function() {
          //that.resize();
          window.screenWidth = document.body.clientWidth;
          that.screenWidth = window.screenWidth;
        },
        false
      );
    } else if (window.attachEvent) {
      // Internet Explorer 5 or above
      window.attachEvent("onresize", function() {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
        //that.resize();
      });
    }
  },
  watch: {
    screenWidth(val) {
      if (!this.timer) {
        this.screenWidth = val;
        this.timer = true;
        let self = this;
        setTimeout(function() {
          self.resize();
          self.timer = false;
        });
      }
    },
    schedules: function() {
      this.loadScheduleData();
    },
    selectedDay: function() {
      if (this.localOptions.oneDayOnly) {
        if (this.headerList && this.headerList.length > 1) {
          this.headerList[1] = this.originalHeaderList[this.selectedDay];
        }
      }
    },
    options: function() {
      if (!!this.options) {
        this.localOptions = this.options;
        this.loadOptions();
        this.loadScheduleData();
      }
    }
  },
  components: {
    calendarColorBlock
  }
};
</script>



// WEBPACK FOOTER //
// src/components/courseCalendar.vue